const constants = require('@/util/constants')
require('./config')

/**
 * 分页获取分公司
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getCompanies (page, size, successcb, failedcb) {
  axios.get('/api/company/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建分公司
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createCompany (name, description, regions, successcb, failedcb) {
  axios.post('/api/company/create', {
    name,
    description,
    regions,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新分公司
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateCompany (cid, name, description, regions, successcb, failedcb) {
  axios.post('/api/company/update', {
    cid,
    name,
    description,
    regions,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除分公司
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteCompany (cid, successcb, failedcb) {
  axios.post('/api/company/delete', {
    cid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索分公司
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterCompanies (page, size, name, successcb, failedcb) {
  axios.get('/api/company/filter', {
    params: {
      'page': page,
      'size': size,
      'name': name,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
